var TextLabel;
(function (TextLabel) {
    TextLabel["LOGO_LABEL"] = "logo-label";
    TextLabel["LOGO_TOOLTIP"] = "logo-tooltip";
    TextLabel["LIVE_INDICATOR_TEXT"] = "live-indicator-text";
    TextLabel["LIVE_SYNC_LABEL"] = "live-sync-button-label";
    TextLabel["LIVE_SYNC_TOOLTIP"] = "live-sync-button-tooltip";
    TextLabel["ENTER_FULL_SCREEN_LABEL"] = "enter-full-screen-label";
    TextLabel["ENTER_FULL_SCREEN_TOOLTIP"] = "enter-full-screen-tooltip";
    TextLabel["EXIT_FULL_SCREEN_LABEL"] = "exit-full-screen-label";
    TextLabel["EXIT_FULL_SCREEN_TOOLTIP"] = "exit-full-screen-tooltip";
    TextLabel["ENTER_PICTURE_IN_PICTURE_LABEL"] = "enter-picture-in-picture-button-label";
    TextLabel["ENTER_PICTURE_IN_PICTURE_TOOLTIP"] = "enter-picture-in-picture-button-tooltip";
    TextLabel["EXIT_PICTURE_IN_PICTURE_LABEL"] = "exit-picture-in-picture-button-label";
    TextLabel["EXIT_PICTURE_IN_PICTURE_TOOLTIP"] = "exit-picture-in-picture-button-tooltip";
    TextLabel["PLAY_CONTROL_LABEL"] = "play-control-label";
    TextLabel["PAUSE_CONTROL_LABEL"] = "pause-control-label";
    TextLabel["PROGRESS_CONTROL_LABEL"] = "progress-control-label";
    TextLabel["PROGRESS_CONTROL_VALUE"] = "progress-control-value";
    TextLabel["UNMUTE_CONTROL_LABEL"] = "unmute-control-label";
    TextLabel["UNMUTE_CONTROL_TOOLTIP"] = "unmute-control-label";
    TextLabel["MUTE_CONTROL_LABEL"] = "mute-control-label";
    TextLabel["MUTE_CONTROL_TOOLTIP"] = "mute-control-tooltip";
    TextLabel["VOLUME_CONTROL_LABEL"] = "volume-control-label";
    TextLabel["VOLUME_CONTROL_VALUE"] = "volume-control-value";
    TextLabel["DOWNLOAD_BUTTON_LABEL"] = "download-button-label";
    TextLabel["DOWNLOAD_BUTTON_TOOLTIP"] = "download-button-tooltip";
})(TextLabel || (TextLabel = {}));
export default TextLabel;
//# sourceMappingURL=text-labels.js.map